import { defaults } from 'underscore';
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';


/**
 * Upsert the result of `transformer(props)` into `this.props` for the WrappedComponent.
 * @param {React.Component} WrappedComponent - component to wrap
 * @param {function} transformer - function that receives props and returns props
 * @returns {React.Component} an enhanced version of the argument
 */
export const WithTransformProps = (WrappedComponent, transformer = props => props) => {
  const HoC = props => (<WrappedComponent {...defaults(transformer(props), props)} />);

  HoC.displayName = `WithTransformProps(${getDisplayName(WrappedComponent)})`;

  return hoistNonReactStatics(HoC, WrappedComponent);
};
